import { styled } from '@mui/material/styles';

/**
 * Single document scrollport: title header, tabs, body, and copyright all scroll
 * together. Used in both FlexibleLayout panels and DocumentSoloShell (hash share).
 */
export const StyledContent = styled('div')({
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  '@media print': {
    height: 'auto',
    overflow: 'visible',
    display: 'block',
  },
});
